import { Text } from '@/components/text';
import { formatDuration } from '@/utils/format';
import { tv } from '@/utils/styles';

interface RouteTooltipProps {
  title: string;
  description?: string;
  durationSeconds: number;
  isShortTransfer?: boolean;
}

const RouteTooltip = ({ title, durationSeconds, description, isShortTransfer = false }: RouteTooltipProps) => {
  const { base, alertBox } = styles();

  return (
    <div className={base()}>
      {isShortTransfer && (
        <div className={alertBox()}>
          <Text className="m-0 text-sm">
            <b>Caution: Short Transfer.</b>
            <br />
            Please check viability with carrier.
          </Text>
        </div>
      )}
      <div className="flex items-center justify-between gap-x-4">
        <Text variant="secondary" className="m-0 font-medium">
          {title}
        </Text>
        <Text variant="sm" className="m-0 whitespace-nowrap">
          {formatDuration(durationSeconds)}
        </Text>
      </div>
      {description && (
        <Text variant="sm" className="text-1 mb-0 mt-1 leading-snug">
          {description}
        </Text>
      )}
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'min-w-60 max-w-60 p-2 text-left',
    alertBox:
      '-mx-4 -mt-3 mb-4 rounded-t-md bg-states-warning-backgroundColor px-4 py-2 leading-snug text-text-primary [&_b]:font-medium',
  },
});

export { RouteTooltip };
